import { render, staticRenderFns } from "./OpenIssue.vue?vue&type=template&id=ed53187e&"
import script from "./OpenIssue.vue?vue&type=script&lang=js&"
export * from "./OpenIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports